"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const viem_1 = require("viem");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const safeTransferFrom_json_1 = __importDefault(require("@framework/abis/json/ERC1155Simple/safeTransferFrom.json"));
const safeTransferFrom_json_2 = __importDefault(require("@framework/abis/json/ERC721Simple/safeTransferFrom.json"));
const transfer_json_1 = __importDefault(require("@framework/abis/json/ERC20Simple/transfer.json"));
const utils_1 = require("../../../utils");
const dialogs_1 = require("../../../dialogs");
const dialog_1 = require("./dialog");
const TransferButton = (props) => {
    const { className, contract, contract: { address, contractFeatures, contractType, id }, disabled, variant, } = props;
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { address: walletAddress } = (0, wagmi_1.useAccount)();
    const { sendTransaction } = (0, wagmi_1.useSendTransaction)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        const asset = values.token.components[0];
        if (asset.tokenType === types_1.TokenType.NATIVE) {
            return sendTransaction({
                to: values.address,
                value: (0, viem_1.parseEther)(asset.amount),
            });
        }
        else if (asset.tokenType === types_1.TokenType.ERC20) {
            return writeContractAsync({
                address: address,
                abi: transfer_json_1.default,
                functionName: "transfer",
                args: [values.address, asset.amount],
            });
        }
        else if (asset.tokenType === types_1.TokenType.ERC721 || asset.tokenType === types_1.TokenType.ERC998) {
            return writeContractAsync({
                address: address,
                abi: safeTransferFrom_json_2.default,
                functionName: "safeTransferFrom",
                args: [walletAddress, values.address, asset.token.tokenId],
            });
        }
        else if (asset.tokenType === types_1.TokenType.ERC1155) {
            return writeContractAsync({
                address: address,
                abi: safeTransferFrom_json_1.default,
                functionName: "safeTransferFrom",
                args: [walletAddress, values.address, asset.token.tokenId, asset.amount, "0x"],
            });
        }
        else {
            throw new Error("unsupported token type");
        }
    });
    const handleTransferConfirm = async ({ data }) => {
        await metaFn(data);
    };
    const handleTransfer = () => {
        openDialog(dialogs_1.GlobalDialogKeys.TRANSFER, contract, {
            initialValues: {
                token: (0, mui_inputs_asset_1.getEmptyToken)(contractType, id),
                address: "",
            },
            validationSchema: dialog_1.transferValidationSchema,
            message: "dialogs.transfer",
            testId: "TokenTransferForm",
            onExternalConfirm: handleTransferConfirm,
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleTransfer, icon: icons_material_1.Send, message: "form.buttons.transfer", className: className, dataTestId: "TransferButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract) || contractFeatures.includes(types_1.ContractFeatures.SOULBOUND), variant: variant }));
};
exports.TransferButton = TransferButton;
//# sourceMappingURL=index.js.map